import React from 'react';
import _ from 'lodash';
import { Card, CardBody, Collapse } from 'reactstrap';
import classnames from 'classnames';

import CardTitle from 'app/components/general/CardTitle';

interface ICardGroupProps {
  children: React.ReactNode;
  title: string;
  notification: string;
  collapseable: boolean;
  isOpen: boolean;
  className: string;
  toggleOpen: Function;
}

interface ICardGroupState {
  isOpen: boolean;
}
export default class CardGroup extends React.Component<ICardGroupProps> {
  static defaultProps: ICardGroupProps = {
    children: undefined,
    title: undefined,
    notification: undefined,
    collapseable: false,
    isOpen: true,
    toggleOpen: undefined,
    className: '',
  };

  state: ICardGroupState = {
    isOpen: true,
  };

  toggleOpen = (): void => {
    if (this.props.toggleOpen !== undefined) {
      this.props.toggleOpen();
    } else {
      this.setState((prevState: ICardGroupState) => ({
        isOpen: !prevState.isOpen,
      }));
    }
  };

  renderNormalCardGroup = () => (
    <Card className={this.props.className}>
      {!_.isEmpty(this.props.title) && (
        <CardTitle notification={this.props.notification} isOpen={this.props.isOpen}>
          {this.props.title}
        </CardTitle>
      )}
      <Collapse isOpen={this.props.isOpen}>
        <CardBody>{this.props.children}</CardBody>
      </Collapse>
    </Card>
  );

  renderColapseableCardGroup = () => (
    <Card className={classnames('collapseable', this.props.className, {
      'is-open': this.state.isOpen && this.props.isOpen,
    })}
    >
      {!_.isEmpty(this.props.title) && (
        <CardTitle
          notification={this.props.notification}
          onClick={this.toggleOpen}
          withArrow
          isOpen={this.state.isOpen && this.props.isOpen}
        >
          {this.props.title}
        </CardTitle>
      )}
      <Collapse isOpen={this.state.isOpen && this.props.isOpen}>
        <CardBody>{this.props.children}</CardBody>
      </Collapse>
    </Card>
  );

  render(): React.ReactNode {
    if (this.props.collapseable) {
      return this.renderColapseableCardGroup();
    }
    return this.renderNormalCardGroup();
  }
}
